// @core/api/endpoints/billing/create_credit_grant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateCreditGrantRequest,
  CreateCreditGrantResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Grant credit to billing account
 * Grants credit to a billing account that can be applied to future invoices. Credits can have optional expiration dates.
 */
export async function CreateCreditGrant(
  billingAccountId: string,
  data: CreateCreditGrantRequest,
  options?: RequestOptions
): Promise<CreateCreditGrantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/credits`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.post<CreateCreditGrantResponse>(requestPath, data, requestOptions);
}
